import { Select, Spin } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import debounce from "lodash/debounce";

export default function DebounceSelect({
  fetchOptions,
  labelInValue = true,
  minSize = 4,
  debounceTimeout = 300,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const fetchRef = useRef(0);
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      if (value.length >= minSize) {
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        setOptions([]);
        setFetching(true);
        fetchOptions(value)
          .then((newOptions) => {
            if (fetchId !== fetchRef.current) {
              // for fetch callback order
              return;
            }
            setOptions(newOptions);
            setFetching(false);
          })
          .finally(() => setHasFetched(true));
      } else {
        setOptions([]);
        setHasFetched(false);
      }
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      labelInValue={labelInValue}
      showSearch
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={
        fetching ? <Spin size="small" /> : hasFetched ? "Nessun risultato" : "Digita per cercare"
      }
      {...props}
      options={options}
    />
  );
}
